import { Modal, Button, Form } from "react-bootstrap";
import { useState, useEffect } from "react";
import axios from "axios";
import useApiError from "../../../hooks/useApiError";

export default function CheckOutModal({
  show,
  onHide,
  selected,
  refresh,
  userData,
  API_BASE
}) {
   const handleAPIError = useApiError();
  const [extraCharges, setExtraCharges] = useState(0);
  const [loading, setLoading] = useState(false);

  // reset when modal opens
  useEffect(() => {
    if (show) {
      setExtraCharges(0);
    }
  }, [show]);

  const handleCheckout = async () => {
    if (!selected) return;

    try {
      setLoading(true);

      await axios.put(
        `${API_BASE}reservations/${selected._id}/checkout`,
        {
          extraCharges: Number(extraCharges),
          branch: userData.branch
        },
        {
          headers: {
            Authorization: `Bearer ${userData.token}`
          }
        }
      );

      refresh();
      onHide();

    } catch (error) {
      console.error("Checkout failed", error);
      alert("Checkout failed");
        handleAPIError(error.response?.data);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Room Check-Out</Modal.Title>
      </Modal.Header>

      <Modal.Body>

        {selected && (
          <>
            <p>
              <strong>Room:</strong> {selected.roomId}
            </p>

            <p>
              <strong>Guest:</strong> {selected.guestName}
            </p>
          </>
        )}

        <Form.Group>
          <Form.Label>Extra Charges</Form.Label>
          <Form.Control
            type="number"
            value={extraCharges}
            onChange={(e) => setExtraCharges(e.target.value)}
            min="0"
          />
        </Form.Group>

      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>

        <Button
          variant="danger"
          onClick={handleCheckout}
          disabled={loading}
        >
          {loading ? "Processing..." : "Complete Check-Out"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}